/**
 * 定额管理路由
 */
const WaterPriceRouter = {
  path: 'waterPrice',
  name: 'WaterPrice',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/WaterPrice/index')
}
export default WaterPriceRouter
